export const state = {
  connection: null // websocket connection
}

export const getters = {
  connection: (state) => {
    return this.connection
  }
}

export const mutations = {
  SET_CONNECTION (state, conn) {
    state.connection = conn
  }
}
